/** Match Recharts demo defaults for the entrance “draw” animation. */
export const CHART_ANIMATION_DURATION_MS = 1500;
export const CHART_ANIMATION_EASING = "ease";

/** Stagger series so multi-series charts still read as a progressive draw. */
export function seriesAnimationBegin(index: number): number {
  return Math.min(index * 120, 480);
}

/**
 * Remount key so filter/data changes replay the entrance animation
 * instead of the subtler path-morph update.
 */
export function chartMountKey(
  data: readonly Record<string, string | number>[],
  xKey: string,
  seriesKeys: readonly string[],
  extra = "",
): string {
  const n = data.length;
  const first = n ? data[0]?.[xKey] : "";
  const last = n ? data[n - 1]?.[xKey] : "";
  return [extra, n, first, last, seriesKeys.join("|")].join(":");
}
